import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from '../../shared/dto-has-api.model';
import { RedactionExceptionListDto } from './redaction-exception-list.dto';

@Api('api/app/phrase-type')
export class PhraseTypeDto extends DtoHasApi {
  id: number;
  name: string;
  displayName: string;
  supportedLanguages: string;
  isUsedInRecognition: boolean;
  isEnabled: boolean;
  exceptions: RedactionExceptionListDto[];
}
